import ReStock from "react-stockcharts";
import defaultOptions from "../constants/customizedIndicatorOptions";

import * as ActionTypes from "../constants/ActionTypes";
import * as ChartTypes from "constants/ChartTypes";
import * as Utils from "utils";

var { CHART_PAGE_LAYOUT_CHANGE, ESCAPE, WINDOW_RESIZE, CHART_PAGE_RESIZE_COMPLETE } = ActionTypes;

var { CHART_SET_PERIOD } = ActionTypes;
var { CHART_PAGE_SET_DATA } = ActionTypes;
var { CHART_SHOW_SETTINGS } = ActionTypes;
var { CHART_SHOW_INDICATOR_SETTINGS, CHART_HIDE_INDICATOR_SETTINGS } = ActionTypes;

var { CHART_PAGE_EXCHANGE_DROPDOWN_TOGGLE, CHART_PAGE_EXCHANGE_SELECT } = ActionTypes;
var { CHART_PAGE_SECURITY_FOCUS, CHART_PAGE_SECURITY_SEARCH, CHART_PAGE_LOADING, CHART_PAGE_SECURITY_SELECT } = ActionTypes;
var { CHART_PAGE_CHART_TYPE_DROPDOWN_TOGGLE, CHART_PAGE_CHART_TYPE_SELECT } = ActionTypes;
var { CHART_PAGE_CHART_INDICATOR_DROPDOWN_TOGGLE } = ActionTypes;
var { CHART_PAGE_CHART_INDICATOR_ADD, CHART_PAGE_CHART_INDICATOR_REMOVE, CHART_PAGE_CHART_INDICATOR_UPDATE } = ActionTypes;
var { CHART_PAGE_CHART_SETTINGS_DROPDOWN_TOGGLE, CHART_PAGE_CHART_SETTINGS_CHANGE  } = ActionTypes;

var { CHART_PAGE_CHART_INTERACTIVE_INDICATOR_DROPDOWN_TOGGLE } = ActionTypes;
var { CHART_PAGE_CHART_INTERACTIVE_INDICATOR_SET } = ActionTypes;

var { StockscaleTransformer } = ReStock.transforms;

var initialState = {
	chartComponent: [
		{
			layout: "full",
			data: null,
			showSettings: false,
			activePeriod: null,
			settings: {},
			securitySelector: {
				showExchangeSelectorDropDown: false,
				showSearchResultDropDown: false,
				focus: true,
				select: true,
				exchange: "NSE",
				type: "ALL", // INDEX, ALL, EQ
				security: "MSFT_full",
				securityDisplay: "MSFT",
				searchInProgress: false,
				securitySearchResult: {},
				searchError: {
					isError: false
				},
			},
			chartSelector: {
				showDropDown: false,
				chartType: ChartTypes.CANDLESTICK,
				transforms: [ { transform: StockscaleTransformer } ],
				options: {},
			},
			indicators: {
				showDropDown: false,
				list: [{
					chartId: 2,
					dataSeriesId: 0,
					options: defaultOptions.MACD,
					type: "MACD",
				}]
			},
			interactiveIndicator: {
				showDropDown: false,
				type: "Crosshair"
			},
			chartSettings: {
				showDropDown: false,
				settings: {
					showGrid: true
				}
			}
		},/*
		{
			layout: "bottom",
			data: null,
			showSettings: false,
			settings: {},
			securitySelector: {
				showExchangeSelectorDropDown: false,
				focus: false,
				select: false,
				exchange: "NSE",
				type: "ALL", // INDEX, ALL, EQ
				security: "MSFT",
				searchInProgress: false,
				securitySearchResult: {},
				searchError: {
					isError: false
				},
			},
			chartSelector: {
				showDropDown: false,
				chartType: ChartTypes.CANDLESTICK,
				transforms: [ { transform: StockscaleTransformer } ],
				options: {},
			},
			indicators: {
				showDropDown: false,
				list: []
			},
			chartSettings: {
				showDropDown: false,
				settings: {
					showGrid: true
				}
			}
		},*/
	],
	resized: true
};
// "full"
// "top", "bottom"
// "top-left", "top-right", "bottom-left", "bottom-right"

function getEachDimension(n, width, height) {
	var eachWidth = n <=3 ? width - 15 : (width - 30) / 2;
	var eachHeight = n === 1 
		? height - 15 - 34
		: n === 2 || n === 4
			? (height - (15 * 2 + 34 * 2)) / 2 - 1
			: (height - (15 * 2 + 34 * 3)) / 3 - 1;
	return { width: eachWidth, height: eachHeight };
}

export default function(state = initialState, action) {
	// console.log(state, action);
	switch (action.type) {
	case CHART_PAGE_LAYOUT_CHANGE: {
		var { width, height, chartComponent } = state;
		var l = action.layout.length;
		var dim = getEachDimension(l, width, height);
		// console.log(width, height, dim);
		let last = chartComponent[chartComponent.length - 1];
		let newChartComponent = action.layout
			.map((each, i) => {
				if (state.chartComponent.length > i) {
					return {...state.chartComponent[i], layout: each, ...dim };
				}
				return {...last, layout: each, ...dim };
			});

		return { ...state, chartComponent: newChartComponent };
	}
	case CHART_PAGE_SET_DATA: {
		// console.log("CHART_PAGE_SET_DATA", action);
		var { chartComponent } = state;
		var newChartComponent = chartComponent.map((each, idx) => {
			if (idx === action.index) return { ...each, data: action.data };
			return each;
		});
		return { ...state, chartComponent: newChartComponent };
	}
	case CHART_SHOW_SETTINGS: {
		var { chartComponent } = state;
		var newChartComponent = chartComponent.map((each, idx) => {
			if (idx === action.index) return { ...each, showSettings: true, settingsType: "Chart", settings: action.settings };
			return each;
		});
		return { ...state, chartComponent: newChartComponent };
	}
	case CHART_SHOW_INDICATOR_SETTINGS: {
		var { chartComponent } = state;
		var indicatorToBeChanged = chartComponent[action.index]
			.indicators.list
			.filter(each => each.chartId === action.settings.chartId)
			.filter(each => each.dataSeriesId === action.settings.dataSeriesId)[0];

		// console.log(action.settings, indicatorToBeChanged);
		var newChartComponent = chartComponent.map((each, idx) => {
			if (idx === action.index) {
				return {
					...each,
					showSettings: true,
					settingsType: "Indicator",
					settings: {
						...action.settings,
						indicatorType: indicatorToBeChanged.type,
					}
				};
			}
			return each;
		});
		return { ...state, chartComponent: newChartComponent };
	}
	case CHART_HIDE_INDICATOR_SETTINGS: {
		var { chartComponent } = state;
		var newChartComponent = chartComponent.map((each, idx) => {
			if (idx === action.index) return { ...each, showSettings: false, settings:{} };
			return each;
		});
		return { ...state, chartComponent: newChartComponent };
	}
	case CHART_PAGE_EXCHANGE_DROPDOWN_TOGGLE: {
		state = handleEscape(state);
		let newComponents = state.chartComponent
			.map((each, idx) => {
				if (idx === action.index) {
					return exchangeSelectorDropDownToggle(each, action.value, false);
				}
				return exchangeSelectorDropDownToggle(each, false, false);
			});
		return { ...state, chartComponent: newComponents };
	}
	case CHART_PAGE_SECURITY_FOCUS: {
		state = handleEscape(state);
		let newComponents = state.chartComponent
			.map((each, idx) => {
				if (idx === action.index) {
					return exchangeSelectorDropDownToggle(each, false, true);
				}
				return exchangeSelectorDropDownToggle(each, false, false);
			});
		return { ...state, chartComponent: newComponents };
	}
	case CHART_PAGE_EXCHANGE_SELECT: {
		let newComponents = state.chartComponent
			.map((each, idx) => {
				if (idx === action.index) {
					return exchangeSelectorSelectExchange(each, action.exchange);
				}
				return each;
			});
		return { ...state, chartComponent: newComponents };
	}
	case CHART_PAGE_SECURITY_SEARCH: {
		// console.log(action);
		let newComponents = state.chartComponent
			.map((each, idx) => {
				if (idx === action.index) {
					return setSearchResult(each, action.securities);
				}
				return each;
			});
		return { ...state, chartComponent: newComponents };
	}
	case CHART_PAGE_LOADING: {
		let newComponents = state.chartComponent
			.map((each, idx) => {
				if (idx === action.index) {
					return searchInProgress(each, action.securities);
				}
				return each;
			});
		return { ...state, chartComponent: newComponents };
	}
	case CHART_PAGE_CHART_TYPE_DROPDOWN_TOGGLE: {
		state = handleEscape(state);
		let newComponents = state.chartComponent
			.map((each, idx) => {
				if (idx === action.index) {
					return chartTypeSelectorDropDownToggle(each, action.value);
				}
				return each;
			});
		return { ...state, chartComponent: newComponents };
	}
	case CHART_PAGE_CHART_TYPE_SELECT: {
		let newComponents = state.chartComponent
			.map((each, idx) => {
				if (idx === action.index) {
					return chartTypeSelect(each, action.chartType, action.transforms);
				}
				return each;
			});
		return { ...state, chartComponent: newComponents };
	}
	case CHART_PAGE_CHART_INDICATOR_DROPDOWN_TOGGLE: {
		state = handleEscape(state);
		let newComponents = state.chartComponent
			.map((each, idx) => {
				if (idx === action.index) {
					return chartIndicatorDropDownToggle(each, action.value);
				}
				return each;
			});
		return { ...state, chartComponent: newComponents };
	}
	case CHART_PAGE_CHART_INDICATOR_ADD: {
		// console.log("CHART_PAGE_CHART_INDICATOR_ADD---", action.indicator);
		let newComponents = state.chartComponent
			.map((each, idx) => {
				if (idx === action.index) {
					return addIndicator(each, action.indicator);
				}
				return each;
			});
		// console.log("HERE..........", newComponents[0].indicators.list);
		return { ...state, chartComponent: newComponents };
	}
	case CHART_PAGE_CHART_INDICATOR_REMOVE: {
		// console.log("CHART_PAGE_CHART_INDICATOR_REMOVE---", action);
		var component = state.chartComponent
			.filter((each, idx) => idx === action.index)[0];
		var newIndicatorList = component.indicators.list
			.filter(each => !(each.chartId === action.indicator.chartId && each.dataSeriesId === action.indicator.dataSeriesId));

		var newComponents = state.chartComponent
			.map((each, idx) => {
				if (idx === action.index) {
					var newIndicator = { ...component.indicators, list: newIndicatorList };

					return { ...each, indicators: newIndicator, settings: {}, showSettings: false };
				}
				return each;
			});
		// console.log("HERE..........", newComponents[0].indicators.list);
		// return { ...state, chartComponent: newComponents };
		return { ...state, chartComponent: newComponents };
	}
	case CHART_PAGE_CHART_INDICATOR_UPDATE: {
		var component = state.chartComponent
			.filter((each, idx) => idx === action.index)[0];
		// console.log("CHART_PAGE_CHART_INDICATOR_UPDATE---", action, component.indicators.list);
		var newIndicatorList = component.indicators.list
			.map(each => each.chartId === action.indicator.chartId && each.dataSeriesId === action.indicator.dataSeriesId
				? { ...action.indicator, options: { ...each.options, ...action.indicator.options } }
				: each);

		var newComponents = state.chartComponent
			.map((each, idx) => {
				if (idx === action.index) {
					var newIndicator = { ...component.indicators, list: newIndicatorList };

					return { ...each, indicators: newIndicator, settings: {}, showSettings: false };
				}
				return each;
			});
		// console.log("HERE..........", newComponents[0].indicators.list);
		// return { ...state, chartComponent: newComponents };
		return { ...state, chartComponent: newComponents };
		// return state;
	}
	case CHART_PAGE_CHART_INTERACTIVE_INDICATOR_DROPDOWN_TOGGLE: {
		state = handleEscape(state);
		let newComponents = state.chartComponent
			.map((each, idx) => {
				if (idx === action.index) {
					return chartInteractiveIndicatorDropDownToggle(each, action.value);
				}
				return each;
			});
		return { ...state, chartComponent: newComponents };
	}
	case CHART_PAGE_CHART_INTERACTIVE_INDICATOR_SET: {
		let newComponents = state.chartComponent
			.map((each, idx) => {
				if (idx === action.index) {
					return chartInteractiveIndicatorSelect(each, action.indicator);
				}
				return each;
			});
		return { ...state, chartComponent: newComponents };
	}
	case CHART_PAGE_CHART_SETTINGS_DROPDOWN_TOGGLE: {
		state = handleEscape(state);
		let newComponents = state.chartComponent
			.map((each, idx) => {
				if (idx === action.index) {
					return chartSettingsDropDownToggle(each, action.value);
				}
				return each;
			});
		return { ...state, chartComponent: newComponents };
		// console.log(action);
		return state;
	}
	case CHART_PAGE_CHART_SETTINGS_CHANGE: {
		// console.log("HERE..........", action.settings);

		let newComponents = state.chartComponent
			.map((each, idx) => {
				if (idx === action.index) {
					return changeSettings(each, action.settings);
				}
				return each;
			});
		return { ...state, chartComponent: newComponents };
	}
	case CHART_SET_PERIOD: {
		// console.log("CHART_SET_PERIOD", action);
		var { chartComponent } = state;
		var newChartComponent = chartComponent.map((each, idx) => {
			if (idx === action.index) return { ...each, activePeriod: action.period };
			return each;
		});
		return { ...state, chartComponent: newChartComponent };
	}
	case ESCAPE: {
		// console.log("Escape Action...", action.type);
		return handleEscape(state, false);
	}
	case CHART_PAGE_RESIZE_COMPLETE: {
		var { chartComponent } = state;
		var { width, height } = action;

		var dim = getEachDimension(chartComponent.length, width, height);

		var newChartComponent = chartComponent.map(each => ({ ...each, ...dim }));

		// console.log("CHART_PAGE_RESIZE_COMPLETE...", action);

		return { ...state, chartComponent: newChartComponent, width, height , resized: false };
	}
	case WINDOW_RESIZE: {
		// console.log("WINDOW_RESIZE...", action);
		return { ...state, resized: true };
	}
	default:
		return state;
	}
}

function exchangeSelectorDropDownToggle(singleChartComponent, value, focus) {
	let securitySelector = {
		...singleChartComponent.securitySelector,
		showExchangeSelectorDropDown: value,
		focus: focus,
		showSearchResultDropDown: false,
		select: true
	};
	return {
		...singleChartComponent,
		securitySelector
	};
}

function exchangeSelectorSelectExchange(singleChartComponent, exchange) {
	let securitySelector = {
		...singleChartComponent.securitySelector,
		showExchangeSelectorDropDown: false,
		exchange,
		focus: true,
		select: true
	};
	return {
		...singleChartComponent,
		securitySelector
	};
}

function searchInProgress(singleChartComponent, result) {
	let securitySelector = {
		...singleChartComponent.securitySelector,
		searchInProgress: true,
		select: false,
		showSearchResultDropDown: true,
		securitySearchResult: {},
		searchError: {
			isError: false
		},
	};
	return {
		...singleChartComponent,
		securitySelector
	};
}
function setSearchResult(singleChartComponent, result) {
	let securitySelector = {
		...singleChartComponent.securitySelector,
		searchInProgress: false,
		select: false,
		showSearchResultDropDown: true,
		securitySearchResult: result.result,
		searchError: {
			isError: false
		},
	};
	// console.log(securitySelector);
	return {
		...singleChartComponent,
		securitySelector
	};
}
function chartTypeSelectorDropDownToggle(singleChartComponent, value) {
	let chartSelector = {
		...singleChartComponent.chartSelector,
		showDropDown: value
	};
	return {
		...singleChartComponent,
		chartSelector
	};
}
function chartIndicatorDropDownToggle(singleChartComponent, value) {
	let indicators = {
		...singleChartComponent.indicators,
		showDropDown: value
	};
	return {
		...singleChartComponent,
		indicators
	};
}
function chartInteractiveIndicatorDropDownToggle(singleChartComponent, value) {
	let interactiveIndicator = {
		...singleChartComponent.interactiveIndicator,
		showDropDown: value
	};
	return {
		...singleChartComponent,
		interactiveIndicator
	};
}

function chartTypeSelect(singleChartComponent, chartType, transforms) {
	let chartSelector = {
		...singleChartComponent.chartSelector,
		chartType,
		transforms,
		showDropDown: false,
	};
	return {
		...singleChartComponent,
		chartSelector,
		showSettings: false,
	};
}

function chartInteractiveIndicatorSelect(singleChartComponent, interactiveIndicatorType) {

	let interactiveIndicator = {
		...singleChartComponent.interactiveIndicator,
		type: interactiveIndicatorType,
		showDropDown: false,
	};
	return {
		...singleChartComponent,
		interactiveIndicator,
	};
}

// var indicatorId = 0;
function addIndicator(singleChartComponent, indicator) {
	// indicator.id = indicatorId++;

	let indicators = {
		...singleChartComponent.indicators,
		list: [...singleChartComponent.indicators.list, indicator],
		showDropDown: false,
	};
	return {
		...singleChartComponent,
		indicators
	};
}
function chartSettingsDropDownToggle(singleChartComponent, value) {
	let chartSettings = {
		...singleChartComponent.chartSettings,
		showDropDown: value
	};
	return {
		...singleChartComponent,
		chartSettings
	};
}
function changeSettings(singleChartComponent, settings) {
	let chartSettings = {
		...singleChartComponent.chartSettings,
		settings: { ...settings }
	};
	return {
		...singleChartComponent,
		chartSettings
	};
}
function handleEscape(state, focus) {
	let focusProvider = (focus === undefined)
		? (chartComponent) => chartComponent.securitySelector.focus
		: () => focus;
	let newComponents = state.chartComponent
		.map((each, idx) => exchangeSelectorDropDownToggle(each, false, focusProvider(each)))
		.map((each, idx) => chartTypeSelectorDropDownToggle(each, false))
		.map((each, idx) => chartIndicatorDropDownToggle(each, false))
		.map((each, idx) => chartSettingsDropDownToggle(each, false))
		.map((each, idx) => chartInteractiveIndicatorDropDownToggle(each, false));
	return { ...state, chartComponent: newComponents };
}


/** WEBPACK FOOTER **
 ** ./src/scripts/reducers/chartPage.js
 **/